<script>
  import FreeShippingBanner from "$lib/components/cart/FreeShippingBanner.svelte";
  import SearchRecomendations from "$lib/components/layout/SearchRecomendations.svelte";
  import TinyCardProducts from "$lib/components/global/TinyCardProducts.svelte";
  import Logo from "../Logo.svelte";
  import { customer } from "$lib/state/customer";
  import { dispatchCustomEvent, SEARCH } from "$lib/utils/events";
  import { onMount } from "svelte";
  /**@type {boolean}*/
  export let isOpen;

  /**@type {HTMLDialogElement}*/
  let search;

  /**@typedef {import ('$lib/types/index').PublicProduct} product*/
  /**@type {string[]}*/
  let searchResults = [];
  /**@type {product[][] | ??}*/
  let searchProducts;
  /** @type {HTMLInputElement}*/
  let searchInput;
  /**@type {string}*/
  let searchContent = "";
  /**@type {number}*/
  let timerId;
  let signalController = new AbortController();
  let fetchInProgress = false;
  /**@type {string}*/
  let historyOfSearch;
  /**@type {any}*/
  let error_;
  /**@type {boolean}*/
  let isFirstOpen = false;

  const fetchResults = async () => {
    isFirstOpen = false;
    fetchInProgress = true;
    clearTimeout(timerId);
    if (searchInput.value.length < 1 || searchContent == "") {
      if (fetchInProgress) {
        signalController.abort();
      }
      searchResults = [];
      return;
    }
    try {
      timerId = setTimeout(async () => {
        if (fetchInProgress) {
          signalController.abort();
          signalController = new AbortController();
        }
        let search = await fetch(`/search?q=${searchContent}`, {
          signal: signalController.signal,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        searchResults = await search.json();

        if (search.status == 200) {
          dispatchCustomEvent(SEARCH, searchContent);
          fetchInProgress = false;
          historyOfSearch = searchContent;
        }
        if (searchResults.length > 0) {
          searchProducts = searchResults?.map((item) => [item]);
        } else {
          searchProducts = null;
        }
      }, 500);
    } catch (error) {
      error_ = error;
    }
  };

  const closeModal = () => {
    search.close();
    isOpen = false;
    isFirstOpen = true;
  };

  onMount(() => {
    isFirstOpen = true;
  });
</script>

<div class="container">
  <div class="icons">
    <button class="action-btn" on:click={() => search.showModal()}>
      <img src="/images/svg/mobileSearchSvg.svg" alt="search icon" />
      <span>Search</span>
    </button>
    {#if $customer}
    <a href="/customers/account" class="action-btn" on:click={closeModal}>
      <img src="/images/svg/signedIn.svg" alt="search icon" />
      <span>My account</span>
    </a>
    <a href="/customers/signout" class="action-btn" on:click={closeModal}>
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 97 97">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectángulo_1417" data-name="Rectángulo 1417" width="97" height="97" transform="translate(0.054 0.053)" fill="#fff" stroke="#1f2525" stroke-width="1"/>
          </clipPath>
        </defs>
        <g transform="translate(-0.054 -0.054)">
          <g transform="translate(21.516 0)">
            <path fill="#1f2525" data-name="Trazado 10283" d="M52.6,88.783,11.772,47.958,51.458,8.278A4.848,4.848,0,1,0,44.6,1.422L2.176,43.842a4.594,4.594,0,0,0-.764.624,5.022,5.022,0,0,0,.006,6.989,4.983,4.983,0,0,0,.764.624L45.742,95.639A4.85,4.85,0,1,0,52.6,88.783Z" transform="translate(0 -0.004)"/>
          </g>
        </g>
      </svg>  
      <span>Log Off</span>
    </a>
    {:else}
    <a href="/signup" class="action-btn" on:click={closeModal}>
      <img src="/images/svg/signout.svg" alt="search icon" />
      <span>Log In/Register</span>
    </a>
    {/if}
  </div>
  <div class="rrss">
    <a target="_blank" href="https://www.facebook.com/GelishProfessionalPage">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.71 22.593">
        <path
          id="icons8-facebook_1_"
          data-name="icons8-facebook (1)"
          d="M13.355,2a11.348,11.348,0,0,0-1.7,22.57V16.364H8.848V13.379h2.809V11.393c0-3.288,1.6-4.732,4.335-4.732a15.841,15.841,0,0,1,2.329.141v2.6H16.457c-1.16,0-1.566,1.1-1.566,2.34v1.632h3.4l-.461,2.985H14.893v8.229A11.349,11.349,0,0,0,13.355,2Z"
          transform="translate(-2 -2)"
          fill="#333"
        />
      </svg>
    </a>
    <a target="_blank" href="https://www.instagram.com/GelishProfessional">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.593 22.593">
        <path
          id="icons8-instagram_1_"
          data-name="icons8-instagram (1)"
          d="M9.276,3A6.277,6.277,0,0,0,3,9.276V19.317a6.277,6.277,0,0,0,6.276,6.276H19.317a6.277,6.277,0,0,0,6.276-6.276V9.276A6.277,6.277,0,0,0,19.317,3ZM21.828,5.51a1.255,1.255,0,1,1-1.255,1.255A1.256,1.256,0,0,1,21.828,5.51ZM14.3,8.021A6.276,6.276,0,1,1,8.021,14.3,6.277,6.277,0,0,1,14.3,8.021Zm0,2.51A3.766,3.766,0,1,0,18.062,14.3,3.766,3.766,0,0,0,14.3,10.531Z"
          transform="translate(-3 -3)"
          fill="#333"
        />
      </svg>
    </a>
    <a target="_blank" href="https://www.tiktok.com/@gelishpro">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.593 22.593">
        <path
          id="icons8-tiktok_1_"
          data-name="icons8-tiktok (1)"
          d="M27.944,12c6.167,0,6.65.482,6.65,6.65v9.293c0,6.167-.482,6.65-6.65,6.65H18.65c-6.167,0-6.65-.483-6.65-6.65V18.65c0-6.167.483-6.65,6.65-6.65Zm1.415,10.018v-2.37a3.71,3.71,0,0,1-2.311-.963,3.849,3.849,0,0,1-.963-2.34h-2.37v9.376a1.965,1.965,0,0,1-1.926,1.955,2,2,0,0,1-1.985-1.97,2.064,2.064,0,0,1,2-1.97,1.331,1.331,0,0,1,.578.089v-2.5s-.385-.037-.667-.046a4.422,4.422,0,1,0,4.473,4.444V21.07a10.277,10.277,0,0,0,1.585.711A6.6,6.6,0,0,0,29.358,22.018Z"
          transform="translate(-12 -12)"
          fill="#333"
        />
      </svg>
    </a>
    <a
      target="_blank"
      href="https://www.youtube.com/c/GelishOfficial"
      class="youtube"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.104 20.083">
        <path
          d="M26.579,6.744A3.145,3.145,0,0,0,24.36,4.525C22.4,4,14.552,4,14.552,4S6.7,4,4.744,4.525A3.145,3.145,0,0,0,2.525,6.744,44.739,44.739,0,0,0,2,14.041a44.739,44.739,0,0,0,.525,7.3,3.145,3.145,0,0,0,2.219,2.219c1.958.525,9.808.525,9.808.525s7.85,0,9.808-.525a3.143,3.143,0,0,0,2.219-2.219,44.738,44.738,0,0,0,.525-7.3A44.739,44.739,0,0,0,26.579,6.744ZM12.041,17.3V10.781a.628.628,0,0,1,.941-.543L18.631,13.5a.628.628,0,0,1,0,1.087l-5.648,3.261A.627.627,0,0,1,12.041,17.3Z"
          transform="translate(-2 -4)"
          fill="#333"
        />
      </svg>
    </a>
    <a target="_blank" href="https://twitter.com/GelishPro" class="twitter">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 20">
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectángulo_305"
              data-name="Rectángulo 305"
              width="19"
              height="20"
              fill="#333"
              stroke="#707070"
              stroke-width="1"
            />
          </clipPath>
        </defs>
        <g
          id="Enmascarar_grupo_78"
          data-name="Enmascarar grupo 78"
          clip-path="url(#clip-path)"
        >
          <path
            id="logo"
            d="M11.367,8.265,18.477,0H16.792L10.618,7.177,5.687,0H0L7.457,10.852,0,19.519H1.685L8.2,11.941l5.208,7.579H19.1L11.367,8.265ZM9.059,10.948,8.3,9.867l-6.011-8.6H4.88L9.731,8.208l.756,1.081,6.306,9.02H14.205l-5.146-7.36Z"
            transform="translate(0.061 0.31)"
            fill="#333"
          />
        </g>
      </svg>
    </a>
  </div>
</div>
<dialog bind:this={search}>
  <FreeShippingBanner />
  <div class="top">
    <button on:click={() => search.close()}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 97 97"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectángulo_1417"
              data-name="Rectángulo 1417"
              width="97"
              height="97"
              transform="translate(0.054 0.053)"
              fill="#fff"
              stroke="#707070"
              stroke-width="1"
            />
          </clipPath>
        </defs>
        <g transform="translate(-0.054 -0.054)">
          <g transform="translate(21.516 0)">
            <path
              id="Trazado_10283"
              data-name="Trazado 10283"
              d="M52.6,88.783,11.772,47.958,51.458,8.278A4.848,4.848,0,1,0,44.6,1.422L2.176,43.842a4.594,4.594,0,0,0-.764.624,5.022,5.022,0,0,0,.006,6.989,4.983,4.983,0,0,0,.764.624L45.742,95.639A4.85,4.85,0,1,0,52.6,88.783Z"
              transform="translate(0 -0.004)"
            />
          </g>
        </g>
      </svg>
    </button>
    <div class="logo">
      <Logo />
    </div>
  </div>
  <form class="from-container">
    <input
      type="text"
      name="q"
      bind:this={searchInput}
      on:keyup|preventDefault={fetchResults}
      bind:value={searchContent}
      placeholder="Search"
      autocomplete="off"
    />
  </form>
  {#if isFirstOpen}
    <SearchRecomendations />
  {:else}
    <div class="products">
      {#if fetchInProgress && searchContent.length > 0}
        <div class="loading">
          <span>L</span>
          <span>o</span>
          <span>a</span>
          <span>d</span>
          <span>i</span>
          <span>n</span>
          <span>g</span>
        </div>
      {:else if searchProducts && searchProducts?.length >= 0}
        <div class="text-results">
          <p>{searchProducts?.length} results for "{historyOfSearch}"</p>
          <a
            class="btn-black"
            href={`/search/results?s=${historyOfSearch}`}
            on:click={closeModal}
            aria-labelledby="see-all"
          >
            SEE ALL
          </a>
        </div>
        <ul class="products-container">
          {#each searchProducts as product}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <li on:click={closeModal}>
              <TinyCardProducts product={product[0]} />
            </li>
          {/each}
        </ul>
      {:else}
        <div class="results-container">
          {#if searchContent && searchContent?.length > 0}
            <div class="text-results">
              <p>{searchResults?.length} results for "{searchContent}"</p>
              <a
                class="btn-black"
                href={`/search/results?s=${searchContent}`}
                on:click={closeModal}
                aria-labelledby="see-all"
              >
                SEE ALL
              </a>
            </div>
          {/if}
        </div>
      {/if}
    </div>
  {/if}
</dialog>

<span class="label" id="see-all">SEE ALL</span>

<style>
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  button {
    background-color: transparent;
    border: none;
    color: var(--secondary-color);
  }
  .icons {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .action-btn {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 1rem;
    padding: 0 20px;
    letter-spacing: 1px;
    text-decoration: none;
    font-family: "gotham-book";
  }
  .action-btn img {
    aspect-ratio: 1/1;
    width: 20px;
    height: 20px;
  }
  .rrss {
    display: flex;
    align-items: center;
    padding: 0 0 0 15px;
    gap: 10px;
  }
  .rrss a {
    width: 40px;
    height: 40px;
    padding: 4px;
  }
  .rrss .youtube {
    width: 40px;
    height: 40px;
    padding: 5px 1px 1px 1px;
  }
  .rrss .twitter {
    padding: 6px;
  }
  dialog {
    display: block;
    width: 100svw;
    height: 100vh;
    max-height: 100vh;
    max-width: inherit;
    top: 0;
    left: 0;
    bottom: 0;
    opacity: 0;
    background-color: #f6f6f6;
    transition: all 300ms ease !important;
    transform: translateX(-100%);
    animation: closeModal 300ms ease forwards;
    overflow: hidden;
  }
  dialog[open] {
    animation: openModal 300ms ease forwards;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  @keyframes openModal {
    from {
      opacity: 0;
      transform: translateX(-100%);
    }
    to {
      opacity: 1;
      transform: translateX(0%);
    }
  }
  @keyframes closeModal {
    from {
      opacity: 1;
      transform: translateX(0%);
    }
    to {
      opacity: 0;
      transform: translateX(-100%);
    }
  }
  dialog::backdrop {
    display: none;
  }
  .from-container {
    width: 90%;
    margin: 0 auto;
  }
  .from-container input {
    height: 40px;
    padding: 0 30px;
    border-radius: 30px;
    border: 1px solid #707070;
    font-size: 1rem;
  }
  .top {
    display: grid;
    grid-template-columns: 34px 1fr 34px;
    justify-items: center;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    height: 60px;
  }
  .top button svg {
    width: 22px;
    height: 22px;
  }
  .logo{
    margin-top: -8px;
  }
  .text-results {
    width: 100%;
    text-align: center;
    padding: 20px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }
  .products {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .products-container {
    width: 98%;
    height: 100%;
    margin: 20px auto 20px auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
    align-items: center;
    overflow-y: scroll;
    padding-bottom: 250px;
  }
  .products-container li {
    list-style: none;
    width: 100%;
    height: 100%;
  }
  .loading {
    font-size: 0.8em;
    font-weight: 800;
    text-align: center;
    letter-spacing: 3px;
    width: 100%;
    height: 100%;
    max-height: 3rem;
    font-family: "gotham-bold";
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1px;
  }
  .loading span {
    color: #1e2225;
    display: inline-block;
    margin: 0 -0.05em;
  }
  .loading span {
    animation: loading 0.7s infinite;
  }
  .loading span:nth-child(2) {
    animation-delay: 0.1s;
  }
  .loading span:nth-child(3) {
    animation-delay: 0.2s;
  }
  .loading span:nth-child(4) {
    animation-delay: 0.3s;
  }
  .loading span:nth-child(5) {
    animation-delay: 0.4s;
  }
  .loading span:nth-child(6) {
    animation-delay: 0.5s;
  }
  .loading span:nth-child(7) {
    animation-delay: 0.6s;
  }
  @keyframes loading {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(4px);
    }
  }
  @media (max-width: 375px) {
    .from-container {
      margin: 0 auto;
    }
    .from-container input {
      margin: 0 0 10px 0;
      height: 40px;
    }
    .text-results {
      padding: 0;
    }
    .logo{
      margin: 0;
    }
  }
</style>
